'use strict';

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var pick = require('lodash.pick');

var id = require('../../id');

var DatadogSpanContext = require('../span_context');

var NoopSpanContext = require('../../noop/span_context');

var log = require('../../log');

var traceKey = 'x-datadog-trace-id';
var spanKey = 'x-datadog-parent-id';
var originKey = 'x-datadog-origin';
var samplingKey = 'x-datadog-sampling-priority';
var sampleKey = 'x-datadog-sampled';
var baggagePrefix = 'ot-baggage-';
var b3TraceKey = 'x-b3-traceid';
var b3TraceExpr = /^([0-9a-f]{16}){1,2}$/i;
var b3SpanKey = 'x-b3-spanid';
var b3SpanExpr = /^[0-9a-f]{16}$/i;
var b3ParentKey = 'x-b3-parentspanid';
var b3SampledKey = 'x-b3-sampled';
var b3FlagsKey = 'x-b3-flags';
var b3HeaderKey = 'b3';
var b3HeaderExpr = /^(([0-9a-f]{16}){1,2}-[0-9a-f]{16}(-[01d](-[0-9a-f]{16})?)?|[01d])$/i;
var baggageExpr = new RegExp("^".concat(baggagePrefix, "(.+)$"));
var ddKeys = [traceKey, spanKey, samplingKey, originKey];
var b3Keys = [b3TraceKey, b3SpanKey, b3ParentKey, b3SampledKey, b3FlagsKey, b3HeaderKey];
var logKeys = ddKeys.concat(b3Keys);

var TextMapPropagator =
/*#__PURE__*/
function () {
  function TextMapPropagator(config) {
    _classCallCheck(this, TextMapPropagator);

    this._config = config;
  }

  _createClass(TextMapPropagator, [{
    key: "inject",
    value: function inject(spanContext, carrier) {
      carrier[traceKey] = spanContext.toTraceId();
      carrier[spanKey] = spanContext.toSpanId();
      carrier[sampleKey] = spanContext._traceFlags.sampled ? '1' : '0';

      this._injectOrigin(spanContext, carrier);

      this._injectSamplingPriority(spanContext, carrier);

      this._injectBaggageItems(spanContext, carrier);

      this._injectB3(spanContext, carrier);

      log.debug(function () {
        return "Inject into carrier: ".concat(JSON.stringify(pick(carrier, logKeys)), ".");
      });
    }
  }, {
    key: "extract",
    value: function extract(carrier) {
      var spanContext = this._extractSpanContext(carrier);

      if (!spanContext) return spanContext;

      this._extractOrigin(carrier, spanContext);

      this._extractBaggageItems(carrier, spanContext);

      this._extractSamplingPriority(carrier, spanContext);

      log.debug(function () {
        return "Extract from carrier: ".concat(JSON.stringify(pick(carrier, logKeys)), ".");
      });
      return spanContext;
    }
  }, {
    key: "_injectOrigin",
    value: function _injectOrigin(spanContext, carrier) {
      var origin = spanContext._trace.origin;

      if (origin) {
        carrier[originKey] = origin;
      }
    }
  }, {
    key: "_injectSamplingPriority",
    value: function _injectSamplingPriority(spanContext, carrier) {
      var priority = spanContext._sampling.priority;

      if (Number.isInteger(priority)) {
        carrier[samplingKey] = priority.toString();
      }
    }
  }, {
    key: "_injectBaggageItems",
    value: function _injectBaggageItems(spanContext, carrier) {
      spanContext._baggageItems && Object.keys(spanContext._baggageItems).forEach(function (key) {
        carrier[baggagePrefix + key] = String(spanContext._baggageItems[key]);
      });
    }
  }, {
    key: "_injectB3",
    value: function _injectB3(spanContext, carrier) {
      if (!this._config.experimental.b3) return;
      carrier[b3TraceKey] = spanContext._traceId.toString('hex');
      carrier[b3SpanKey] = spanContext._spanId.toString('hex');
      carrier[b3SampledKey] = spanContext._traceFlags.sampled ? '1' : '0';

      if (spanContext._traceFlags.debug) {
        carrier[b3FlagsKey] = '1';
      }

      if (spanContext._parentId) {
        carrier[b3ParentKey] = spanContext._parentId.toString('hex');
      }
    }
  }, {
    key: "_extractSpanContext",
    value: function _extractSpanContext(carrier) {
      var context = this._extractContext(carrier);

      if (!context) return null;

      if (context.traceFlags.sampled !== false) {
        return new DatadogSpanContext(context);
      } else {
        return new NoopSpanContext(context);
      }
    }
  }, {
    key: "_extractContext",
    value: function _extractContext(carrier) {
      return this._extractDatadogContext(carrier) || this._extractB3Context(carrier);
    }
  }, {
    key: "_extractDatadogContext",
    value: function _extractDatadogContext(carrier) {
      var sampled = this._isSampled(carrier[sampleKey]);

      return this._extractGenericContext(carrier, traceKey, spanKey, {
        sampled: sampled
      }, 10);
    }
  }, {
    key: "_extractB3Context",
    value: function _extractB3Context(carrier) {
      if (!this._config.experimental.b3) return null;

      var b3 = this._extractB3Headers(carrier);

      var debug = b3[b3FlagsKey] === '1';

      var sampled = this._isSampled(b3[b3SampledKey], debug);

      return this._extractGenericContext(b3, b3TraceKey, b3SpanKey, {
        sampled: sampled,
        debug: debug
      });
    }
  }, {
    key: "_extractGenericContext",
    value: function _extractGenericContext(carrier, traceKey, spanKey, traceFlags, radix) {
      if (carrier[traceKey] && carrier[spanKey]) {
        return {
          traceId: id(carrier[traceKey], radix),
          spanId: id(carrier[spanKey], radix),
          traceFlags: traceFlags
        };
      } else if (typeof traceFlags.sampled === 'boolean') {
        return {
          traceId: id(),
          spanId: null,
          traceFlags: traceFlags
        };
      }

      return null;
    }
  }, {
    key: "_extractB3Headers",
    value: function _extractB3Headers(carrier) {
      if (b3HeaderExpr.test(carrier[b3HeaderKey])) {
        return this._extractB3SingleHeader(carrier);
      } else {
        return this._extractB3MultipleHeaders(carrier);
      }
    }
  }, {
    key: "_extractB3MultipleHeaders",
    value: function _extractB3MultipleHeaders(carrier) {
      var b3 = {};

      if (b3TraceExpr.test(carrier[b3TraceKey]) && b3SpanExpr.test(carrier[b3SpanKey])) {
        b3[b3TraceKey] = carrier[b3TraceKey];
        b3[b3SpanKey] = carrier[b3SpanKey];
      }

      if (carrier[b3SampledKey]) {
        b3[b3SampledKey] = carrier[b3SampledKey];
      }

      if (carrier[b3FlagsKey]) {
        b3[b3FlagsKey] = carrier[b3FlagsKey];
      }

      return b3;
    }
  }, {
    key: "_extractB3SingleHeader",
    value: function _extractB3SingleHeader(carrier) {
      var parts = carrier[b3HeaderKey].split('-');

      if (parts[0] === 'd') {
        var _ref;

        return _ref = {}, _defineProperty(_ref, b3SampledKey, '1'), _defineProperty(_ref, b3FlagsKey, '1'), _ref;
      } else if (parts.length === 1) {
        return _defineProperty({}, b3SampledKey, parts[0]);
      } else {
        var _b;

        var b3 = (_b = {}, _defineProperty(_b, b3TraceKey, parts[0]), _defineProperty(_b, b3SpanKey, parts[1]), _defineProperty(_b, b3SampledKey, parts[2] !== '0' ? '1' : '0'), _b);

        if (parts[2] === 'd') {
          b3[b3FlagsKey] = '1';
        }

        return b3;
      }
    }
  }, {
    key: "_extractOrigin",
    value: function _extractOrigin(carrier, spanContext) {
      var origin = carrier[originKey];

      if (typeof carrier[originKey] === 'string') {
        spanContext._trace.origin = origin;
      }
    }
  }, {
    key: "_extractBaggageItems",
    value: function _extractBaggageItems(carrier, spanContext) {
      Object.keys(carrier).forEach(function (key) {
        var match = key.match(baggageExpr);

        if (match) {
          spanContext._baggageItems[match[1]] = carrier[key];
        }
      });
    }
  }, {
    key: "_extractSamplingPriority",
    value: function _extractSamplingPriority(carrier, spanContext) {
      var priority = parseInt(carrier[samplingKey], 10);

      if (Number.isInteger(priority)) {
        spanContext._sampling.priority = parseInt(carrier[samplingKey], 10);
      }
    }
  }, {
    key: "_isSampled",
    value: function _isSampled(sampled, debug) {
      if (debug || sampled === '1') {
        return true;
      } else if (sampled === '0') {
        return false;
      }

      return null;
    }
  }]);

  return TextMapPropagator;
}();

module.exports = TextMapPropagator;